const GroupStar = function gs(star) {
  this.starred = star?.starred;
};

export default GroupStar;
